<template>
	<navigation-select ref="navigation" :title="title" :subtitle="subtitle">
		<navigation-button @click="onDashboard_ClickHandler" route="WatchDashboard" routeStartsWith="WatchDashboard" title="Dashboard" />
		<navigation-button @click="onProfile_ClickHandler" route="WatchProfile" routeStartsWith="WatchProfile" title="Profile" />
		<navigation-button @click="onHeartRate_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'heart-rate' } }" title="Heart Rate" />
		<navigation-button @click="onBloodPressure_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'blood-pressure' } }" title="Blood Pressure" />
		<navigation-button @click="onTemperature_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'temperature' } }" title="Temperature" />
		<navigation-button @click="onBloodSaturation_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'blood-saturation' } }" title="Blood Saturation" />
		<navigation-button @click="onCalories_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'calories' } }" title="Calories" />
		<navigation-button @click="onPedometer_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'pedometer' } }" title="Pedometer" />
		<navigation-button @click="onFalls_ClickHandler" route="WatchBiometricView" :routeStartsWith="{ name: 'WatchBiometricView', args: { type: 'falls' } }" title="Falls" />
		<navigation-button @click="onGeoFencing_ClickHandler" route="WatchGeofencing" routeStartsWith="WatchGeofencing" title="Geo Fencing" />
		<navigation-button @click="onPillBox_ClickHandler" route="WatchPillsManage" routeStartsWith="WatchPillsManage" title="Pills Boxes" />
		<navigation-button @click="onAppointments_ClickHandler" route="WatchAppointment" routeStartsWith="WatchAppointment" title="Appointments" />
		<navigation-button @click="onHealthReports_ClickHandler" route="WatchHealthReports" routeStartsWith="WatchHealthReports" title="Health Reports" />
		<navigation-button @click="onMedicalDocuments_ClickHandler" route="WatchMedicalDocuments" routeStartsWith="WatchMedicalDocuments" title="Medical Documents" />
		<!-- <navigation-button @click="onChat_ClickHandler" route="WatchChat" routeStartsWith="WatchChat" title="Chat" /> -->
	</navigation-select>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationButton from '@/components/navigation/NavigationButton'
import NavigationSelect from '@/components/navigation/NavigationSelect'
export default {
	name: 'user-profile-navigation',
	components: {
		NavigationButton,
		NavigationSelect
	},
	props: {
		patient: {
			type: Object
		}
	},
	data() {
		return {
			subtitle: 'Patient'
		}
	},
	computed: {
		title() {
			if (this.$route.name.startsWith('WatchProfile'))
				return this.$t('Profile')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'heart-rate')
				return this.$t('Heart Rate')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'blood-pressure')
				return this.$t('Blood Pressure')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'temperature')
				return this.$t('Temperature')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'blood-saturation')
				return this.$t('Blood Saturation')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'calories')
				return this.$t('Calories')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'pedometer')
				return this.$t('Pedometer')
			if (this.$route.name.startsWith('WatchBiometricView') && 'type' in this.$route.params && this.$route.params.type === 'falls')
				return this.$t('Falls')
			if (this.$route.name.startsWith('WatchGeofencing'))
				return this.$t('Geo Fencing')
			if (this.$route.name.startsWith('WatchPillsManage'))
				return this.$t('Pills Boxes')
			if (this.$route.name.startsWith('WatchAppointment'))
				return this.$t('Appointments')
			if (this.$route.name.startsWith('WatchHealthReports'))
				return this.$t('Health Reports')
			if (this.$route.name.startsWith('WatchMedicalDocuments'))
				return this.$t('Medical Documents')
			if (this.$route.name.startsWith('WatchChat'))
				return this.$t('Chat')
			return 'Dashboard'
		},
		navigation() {
			return this.$refs.navigation
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	},
	methods: {
		onDashboard_ClickHandler() {
			this.gotAction('WatchDashboard')
			this.navigation.close()
		},
		onProfile_ClickHandler() {
			this.gotAction('WatchProfile')
			this.navigation.close()
		},
		onHeartRate_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'heart-rate' })
			this.navigation.close()
		},
		onBloodPressure_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'blood-pressure' })
			this.navigation.close()
		},
		onTemperature_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'temperature' })
			this.navigation.close()
		},
		onBloodSaturation_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'blood-saturation' })
			this.navigation.close()
		},
		onCalories_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'calories' })
			this.navigation.close()
		},
		onPedometer_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'pedometer' })
			this.navigation.close()
		},
		onFalls_ClickHandler() {
			this.gotAction('WatchBiometricView', { type: 'falls' })
			this.navigation.close()
		},
		onGeoFencing_ClickHandler() {
			this.gotAction('WatchGeofencing')
			this.navigation.close()
		},
		onPillBox_ClickHandler() {
			this.gotAction('WatchPillsManage')
			this.navigation.close()
		},
		onAppointments_ClickHandler() {
			this.gotAction('WatchAppointments')
			this.navigation.close()
		},
		onHealthReports_ClickHandler() {
			this.gotAction('WatchHealthReports')
			this.navigation.close()
		},
		onMedicalDocuments_ClickHandler() {
			this.gotAction('WatchMedicalDocuments')
			this.navigation.close()
		},
		onChat_ClickHandler() {
			this.gotAction('WatchChat')
			this.navigation.close()
		},
		gotAction(route, args = {}) {
			this.$router.push({
				name: route,
				params: Object.assign(
					{ },
					{
						user_uid: this.currentUser.uid,
						watch_id: parseInt(this.patient.id)
					},
					args
				)
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/WatchNavigation.vue